import { Component, Input } from '@angular/core';
import {
  BorderStyle,
  CSSProperties,
  DynamicBannerConfiguration,
  DynamicBannerContent,
  DynamicBannerStyleProperties
} from '../../../../models';
import {
  ElementVerticalAlignType,
  FontStyleType,
  PositionType
} from '../../../../types/common.types';

@Component({
  selector: 'idp-banner-split',
  templateUrl: './banner-split.component.html',
  styleUrls: ['./banner-split.component.scss']
})
export class BannerSplitComponent {
  /** This props holds all content regarding split image banner */
  @Input() content = {} as DynamicBannerContent;
  /**
   * This is the primary configuration for split image banner.
   * You can pass several configuration like device configuration and template configuration
   */
  @Input() config = {} as DynamicBannerConfiguration;
  /** This holds style properties. You can set apply styling according to the use case */
  @Input() styles: DynamicBannerStyleProperties =
    {} as DynamicBannerStyleProperties;

  /** Prepare split image banner container styling */
  get containerStyle(): CSSProperties {
    return {
      borderColor: this.styles?.banner?.borderColor || undefined,
      backgroundColor: this.styles?.banner?.backgroundColor || undefined,
      background: '',
      border: {} as BorderStyle,
      color: '',
      fontColor: '',
      fontSize: '',
      fontStyle: {} as FontStyleType,
      fontType: '',
      fontWeight: '',
      lineHeight: '',
      position: {} as PositionType,
      zIndex: 0,
      width: this.styles?.banner?.width || '100%',
      verticalAlign: {} as ElementVerticalAlignType,
      letterSpacing: ''
    };
  }

  /** Prepare dynamic class for which the banner can be shift to left or right based on the position */
  // eslint-disable-next-line complexity
  get bannerRowClass(): { 'flex-row-reverse': boolean; hasBorder: boolean } {
    return {
      'flex-row-reverse':
        this.styles.textPosition && this.styles.textPosition.position === 'left'
          ? true
          : false,
      hasBorder:
        this.styles.banner &&
        this.styles.banner.borderColor !== '' &&
        this.styles.banner.borderColor !== '&nbsp;'
          ? true
          : false
    };
  }

  /** Check desktop image setting is enabled of not */
  get desktopBannerEnabled(): boolean {
    return this.config.deviceConfig.desktopEnabled &&
      this.content?.imageContent?.desktop?.src
      ? true
      : false;
  }

  /**  check mobile image setting is enabled of not */
  get mobileBannerEnabled(): boolean {
    return this.config.deviceConfig.mobileEnabled &&
      this.content?.imageContent?.mobile?.src
      ? true
      : false;
  }

  /**  check mobile image setting is enabled of not */
  get tabletBannerEnabled(): boolean {
    return this.config.deviceConfig.desktopEnabled &&
      this.content?.imageContent?.tablet?.src
      ? true
      : false;
  }

  /**  generate classes for mobile image id enabled and responsive is turned on */
  get mobileBannerClasses(): string {
    return this.content?.imageContent?.mobile?.src &&
      this.config?.deviceConfig?.responsive
      ? 'banner-col-xs-5 banner-col-sm-5'
      : 'banner-col-12';
  }

  /**  prepare header styling according to the inputs */
  // eslint-disable-next-line complexity
  get headerStyles(): CSSProperties {
    return {
      color: this.styles?.heading?.color || '',
      position: this.styles?.heading?.position || 'left',
      borderColor: this.styles?.banner?.borderColor,
      backgroundColor: this.styles?.banner?.backgroundColor,
      background: '',
      border: {} as BorderStyle,
      fontColor: '',
      fontSize: '',
      fontStyle: {} as FontStyleType,
      fontType: '',
      fontWeight: '',
      lineHeight: '',
      zIndex: 0,
      width: this.styles?.banner?.width || '100%',
      verticalAlign: {} as ElementVerticalAlignType,
      letterSpacing: ''
    };
  }

  /**  prepare header content for full image banner */
  get headerContent(): { text: string; level: string } {
    return {
      text: this.content?.headerText || '',
      level: this.content?.level || ''
    };
  }
}
